import { render } from "./HomeContato.vue?vue&type=template&id=44d624b5&scoped=true"
import script from "./HomeContato.vue?vue&type=script&lang=js"
export * from "./HomeContato.vue?vue&type=script&lang=js"

import "./HomeContato.vue?vue&type=style&index=0&id=44d624b5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44d624b5"]])

export default __exports__